import * as React from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';

export default function EditDialog(props) {
    const { onSave, onClose, selectedValue, open } = props;

    const [vendorName, setVendorName] = React.useState("");
    const [truckRate, setTruckRate] = React.useState("");
    const [tripperRate, setTripperRate] = React.useState("");
    const [tractorRate, setTractorRate] = React.useState("");

    React.useEffect(() => {
        if (selectedValue) {
            setVendorName(selectedValue.name);
            setTruckRate(selectedValue.rate.truck);
            setTripperRate(selectedValue.rate.tripper);
            setTractorRate(selectedValue.rate.tractor);
        }
    }, [selectedValue])

    const handleClose = () => {
        onClose();
    };

    const handleSave = () => {
        onSave({
            truck: parseFloat(truckRate),
            tripper: parseFloat(tripperRate),
            tractor: parseFloat(tractorRate),
        });
    }

    return (
        <Dialog onClose={handleClose} open={open}>
            <DialogTitle>{vendorName}</DialogTitle>
            <Box
                // component="form"
                sx={{
                    '& .MuiTextField-root': { m: 1, width: '25ch' },
                }}
                noValidate
                autoComplete="off"
                style={{ padding: '0 24px' }}
            >
                <div>
                    <div>
                        <TextField
                            id="truck-rate"
                            label="Truck Rate"
                            type="number"
                            value={truckRate}
                            onChange={(e) => setTruckRate(e.target.value)}
                        />
                        <TextField
                            id="tripper-rate"
                            label="Tripper Rate"
                            type="number"
                            value={tripperRate}
                            onChange={(e) => setTripperRate(e.target.value)}
                        />
                        <TextField
                            id="tractor-rate"
                            label="Tractor Rate"
                            type="number"
                            value={tractorRate}
                            onChange={(e) => setTractorRate(e.target.value)}
                        />
                    </div>
                    <div style={{ margin: '10px', float: 'right' }}>
                        <button className="btn btn-primary success" style={{ marginRight: '10px' }} onClick={handleSave}>Save</button>
                        <button className="btn btn-primary success" onClick={() => handleClose()}>Cancel</button>
                    </div>
                </div>
            </Box>
        </Dialog>
    );
}
